import {useEffect, useState} from 'react';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle, WdiModalAppProps} from '@/components/WdiControls';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {DetailGrid, wdiCore} from '@/components/GridWidget';
import {WdiModal} from '@/components/WdiControls/WdiModalForm';
import {Button} from 'antd';


type SalesAndCostProps = {
  dataSource: any[],
  collapsed?: boolean,
  onClick?: () => void,
};
export const SalesAndCostPanel: React.FC<SalesAndCostProps> = (props) => {

  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const {collapsed, onClick} = props;

  useEffect(() => {
    GridApi.searchConfig({id: 'SalesAndCost', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None       
      });

      settings.formSchema.allFields.custSysCode.getDisplayFormater = (text: any, record: any, index: any) => {
        return wdiCore.String.CodeOrName(record.custSysCode, record.custSysName)
      };

      settings.formSchema.allFields.boId2.getDisplayFormater = (text: any, record: any, index: any) => {
        return record.boName2
      };

      settings.formSchema.allFields.ecId1.getDisplayFormater = (text: any, record: any, index: any) => {
        return record.ecName1
      };

      setGridSettings(settings);
      setIsLoaded(true);


      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const {dataSource} = props;

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    }
  };

  return (
    <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_COUNT_INFO} title='销量与费用统计'/>}
              collapsed={true} defaultCollapsed={collapsed == null ? true : !collapsed} onClick={onClick}>
      {isLoaded && <DetailGrid {...pageGridSettings} />}
    </WdiPanel>
  );
};

export const SalesAndCostModalApp: React.FC<WdiModalAppProps> = (props) => {
  return (
    <WdiModal
      title='销量与费用统计'
      width={1350}
      onCancel={() => {
        props.onClose?.();
      }}
      visible={props.visible}
      footer={
        <>
          <Button type="primary" onClick={() => {
            props.onClose?.();
          }}>关闭</Button>
        </>
      }
    >
      <SalesAndCostPanel dataSource={props.data} collapsed={true}/>
    </WdiModal>
  );
};

export default SalesAndCostPanel;


